import React from 'react'
import CardItem from './CardItem';
import './Cards.css';

function Cards() {
  return (
    <div className='cards' id="portfolio">
      <h1 className="previous-work-title"> Our Previous Work </h1>
      <div className="cards__container">
          <div className="cards__wrapper">
              <ul className="cards__items">
                  <CardItem 
                  src="images/airBeauty.png"
                  title="Air Beauty"
                  label="App"
                  href="https://apps.apple.com/gb/app/air-beauty/id1600830509"
                  description="Beauty salon listing service for businesses across New Zealand and Australia."/>
              </ul>
          </div>
      </div>
    </div>
  )
}

export default Cards
